/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-13",
    versionChannel: "nightly",
    buildDate: "2025-06-13T00:07:07.234Z",
    commitHash: "deab8058cc9d3853b7713013e492ff9c59cde24d",
};
